import React, { Component } from 'react';
import PropTypes from 'prop-types';

class DataTypeCellRenderer extends Component {
  renderContent() {
    const { value, data } = this.props;
    if (value && value !== null) {
      if (data.accessible === false) {
        return (<span className="label label-danger text-uppercase">inaccessible field</span>);
      }
      if (value === 'reference' && data && data.reference_to && data.reference_to.length > 0) {
        return (<code>{value}: {data.reference_to.join(', ')}</code>);
      }
      return (<code>{value}</code>);
    }
    return null;
  }

  render() {
    const isGrouped = this.props.node && this.props.node.group;
    if (!isGrouped) {
      return this.renderContent();
    }
    return null;
  }
}

DataTypeCellRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    reference_to: PropTypes.arrayOf(PropTypes.string),
    accessible: PropTypes.bool,
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }).isRequired,
};
DataTypeCellRenderer.defaultProps = {
  value: null,
  data: {},
};

export default DataTypeCellRenderer;
